import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import camelCaseRecursive from 'camelcase-keys-recursive';
import moment from 'moment';
import { indexCompanyAnnouncementsRequest } from '../../../requests/companyAnnouncements';
import CompanyAnnouncementCard from '../../Shared/CompanyAnnouncement/CompanyAnnouncementCard';
import CompanyAnnouncementModalShow from '../../Shared/CompanyAnnouncement/CompanyAnnouncementModalShow';
import CompanyAnnouncementSidePanel from '../../Shared/CompanyAnnouncement/CompanyAnnouncementSidePanel';

const CompanyAnnouncementProfileIndex = () => {
  const dispatch = useDispatch();
  const [announcements, setAnnouncements] = useState([]);
  const [onRequest, setOnRequest] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const [panelShow, setPanelShow] = useState(false);
  const [panelTitle, setPanelTitle] = useState('');
  const [panelContent, setPanelContent] = useState(null);

  const loadAnnouncements = useCallback(() => {
    setOnRequest(true);
    indexCompanyAnnouncementsRequest({
      dispatch,
      params: {
        active: moment().format('DD/MM/YYYY'),
        my_announcements: true
      },
      successCallback: res => {
        const formatted = camelCaseRecursive(res.data.data);
        setAnnouncements(formatted);
      },
      callback: () => setOnRequest(false)
    });
  }, [dispatch]);

  useEffect(() => {
    loadAnnouncements();
  }, [loadAnnouncements]);

  const handleShowInfo = announcement => {
    setPanelTitle('Detalle del Anuncio');
    setPanelContent(<CompanyAnnouncementModalShow announcement={announcement} />);
    setPanelShow(true);
  };

  const handleLoadMore = () => {
    setVisibleCount(prev => Math.min(prev + 3, announcements.length));
  };

  const renderContent = () => {
    if (onRequest) {
      return (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      );
    }

    if (announcements.length > 0) {
      return (
        <>
          <Row>
            {announcements.slice(0, visibleCount).map(item => (
              <Col key={item.id} xs={12} md={4} className="mb-5">
                <CompanyAnnouncementCard location="profile" announcement={item} showInfo={handleShowInfo} />
              </Col>
            ))}
          </Row>

          {announcements.length > visibleCount && (
            <Row className="justify-content-end mt-3">
              <Col xs="auto">
                <Button onClick={handleLoadMore}>Ver más</Button>
              </Col>
            </Row>
          )}
        </>
      );
    }

    return <div className="text-center text-muted my-5">No hay anuncios disponibles.</div>;
  };

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col>
          <h2 className="mb-3 mt-3">Anuncios</h2>
        </Col>
      </Row>

      <div className="yellow-wrapper">{renderContent()}</div>

      <CompanyAnnouncementSidePanel
        title={panelTitle}
        show={panelShow}
        onHide={() => {
          setPanelShow(false);
          setPanelContent(null);
        }}
      >
        {panelContent}
      </CompanyAnnouncementSidePanel>
    </>
  );
};

export default CompanyAnnouncementProfileIndex;
